module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMzMuNDY5OTcgMTMzLjU5MDY2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2Y3ZjhmOTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkV2ZW50YnJpdGVfQXJ0d29yazwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjMzLjQ3LDEzMy41OTA2NkgwVjQuNDEwNjdjMjUuMTY5OTIsMS41MSw1MC4wOTAwOSw2Ljc3LDcyLjc5LDE3LjIzLDM4LjMxMDA2LDE3LjY4LDUzLjI5LDUyLjI4LDgzLjU1LDc4LjgxQzE3NS45MTk5MiwxMTcuNjEwNjgsMjA1LjQzOTk0LDEyOS40NDA2NCwyMzMuNDcsMTMzLjU5MDY2WiIvPjwvc3ZnPg=="


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/overlay_left.svg
 ** module id = 1269
 ** module chunks = 0
 **/